import { render, staticRenderFns } from "./EmbedColumn.vue?vue&type=template&id=5e282bda&scoped=true"
import script from "./EmbedColumn.vue?vue&type=script&lang=js"
export * from "./EmbedColumn.vue?vue&type=script&lang=js"
import style0 from "./EmbedColumn.vue?vue&type=style&index=0&id=5e282bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e282bda",
  null
  
)

export default component.exports